import React, { useEffect } from "react";
import Nav from "../Home/navbar/nav";
import Powering from "./Powering/Powering";
import Ambitiousfuture from "./Ambitiousfuture/Ambitiousfuture";
import Ourmap from "./Ourmap/Ourmap";
import Ourteam from "./Ourteam/Ourteam";
import { Helmet } from "react-helmet";

const WhoWeAre = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Helmet>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Who We Are</title>
        <meta
          name="description"
          content="We provide crafted solutions that bring your ideas to life."
        />
        <link rel="canonical" href="https://www.althisolutions.com/whoWeAre" />
        <meta name="robots" content="index, follow" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Who We Are" />
        <meta
          property="og:url"
          content="https://www.althisolutions.com/whoWeAre"
        />
        <meta
          property="og:image"
          content="https://althisolutions.com/static/media/Team-Work.097b44dc1fe67ba053f0.jpg"
        />
        <meta
          property="og:description"
          content="We provide crafted solutions that bring your ideas to life."
        />
        <meta property="og:site_name" content="Althi Solutions" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Who We Are" />
        <meta
          name="twitter:site"
          content="@Althisolutions"
        />
        <meta
          name="twitter:description"
          content="We provide crafted solutions that bring your ideas to life."
        />
        <meta
          name="twitter:image"
          content="https://althisolutions.com/static/media/Team-Work.097b44dc1fe67ba053f0.jpg"
        />
      </Helmet>

      <Nav />
      <Powering />
      <Ourteam />
      <Ambitiousfuture />
      <Ourmap />
    </>
  );
};

export default WhoWeAre;
